import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-wa-cluster',
	templateUrl:'./WaClusterPluginCompPage.html',
	styles: [],
	styleUrls:['./WaClusterPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaClusterPluginCompPage
{
	mdContent_1128 = `\`\`\`java
import com.jwebmp.webawesome.components.WaCluster;
\`\`\``;
	mdContent_1129 = `\`\`\`java
new WaCluster&lt;&gt;()
\`\`\``;
}
